export default {
  specialCharactersSets: [{
    title: 'Latin',
    list: [
      { char: '&iexcl;', desc: 'INVERTED EXCLAMATION MARK' },
      { char: '&cent;', desc: 'CENT SIGN' },
      { char: '&pound;', desc: 'POUND SIGN' },
      { char: '&curren;', desc: 'CURRENCY SIGN' },
      { char: '&yen;', desc: 'YEN SIGN' },
      { char: '&brvbar;', desc: 'BROKEN BAR' },
      { char: '&sect;', desc: 'SECTION SIGN' },
      { char: '&uml;', desc: 'DIAERESIS' },
      { char: '&copy;', desc: 'COPYRIGHT SIGN' },
      { char: '&trade;', desc: 'TRADEMARK SIGN' },
      { char: '&ordf;', desc: 'FEMININE ORDINAL INDICATOR' },
      { char: '&laquo;', desc: 'LEFT-POINTING DOUBLE ANGLE QUOTATION MARK' },
      { char: '&not;', desc: 'NOT SIGN' },
      { char: '&reg;', desc: 'REGISTERED SIGN' },
      { char: '&macr;', desc: 'MACRON' },
      { char: '&deg;', desc: 'DEGREE SIGN' },
      { char: '&plusmn;', desc: 'PLUS-MINUS SIGN' },
      { char: '&acute;', desc: 'ACUTE ACCENT' },
      { char: '&micro;', desc: 'MICRO SIGN' },
      { char: '&para;', desc: 'PILCROW SIGN' },
      { char: '&middot;', desc: 'MIDDLE DOT' },
    ]
  }]
};
